(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .factory('User', User);

    User.$inject = ['$resource', 'Principal'];

    function User($resource, Principal) {
        var service = $resource('api/users/:login/:fromLdap', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},
            'fromLdap': {method: 'GET', params: {fromLdap: 'fromLdap'}, isArray: true},
        });

        /**
         * Restituisce true se l'utente appartiene ad una o più delle 
         * commissioni fornite, false altrimenti.
         * 
         * @param {type} utente
         * @param {type} commissions
         * @returns {Boolean}
         */
        service.hasAnyCommission = function (utente, commissions, legislatura) {
            if (!utente || !commissions) { // || !utente.commissioni
                return false;
            }
            for (var i = 0; i < commissions.length; i++) {
                
                var id = getIdSoggetto(commissions[i]);
                if (utente.commissioni && utente.commissioni.indexOf(id) > -1) {
                    return true;
                }
                // Cerca nelle authority di legislatura -> Se trovo almeno un oggetto legislaturaAuthority
                // Il quale ha almeno un oggetto commissioneRuoloAssociato.commissione con lo stesso id di quello cercato -> Ritorna TRUE
                if (utente.legislaturaAuthorities && utente.legislaturaAuthorities.some( function (legiAuth) {
                    if(service.isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                        if(legiAuth.commissioneRuoloAssociato && 
                            legiAuth.commissioneRuoloAssociato.some( function (commRuoloAssoc) {
                                return commRuoloAssoc.commissione && commRuoloAssoc.commissione.id === id;
                            })
                        ) { 
                            return true;
                        } else {
                            return false;
                        }
                    }
                })) {
                    return true;
                }
            }
            return false;
        };

        /**
         * Restituisce true se l'utente appartiene ad una o più dei soggetti 
         * esterni forniti, false altrimenti.
         * 
         * @param {type} utente
         * @param {type} subjects
         * @returns {Boolean}
         */
        service.hasAnyExternalSubject = function (utente, subjects, legislatura) {
            if (!utente || !subjects ) { // || !utente.soggettiEsterni
                return false;
            }
            for (var i = 0; i < subjects.length; i++) {
                
                var id = getIdSoggetto(subjects[i]);
                if (utente.soggettiEsterni && utente.soggettiEsterni.indexOf(id) > -1) {
                    return true;
                }
                // Cerca nelle authority di legislatura -> Se trovo almeno un oggetto legislaturaAuthority
                // Il quale ha almeno un oggetto soggettiEsterni con lo stesso id di quello cercato -> Ritorna TRUE
                if (utente.legislaturaAuthorities && utente.legislaturaAuthorities.some( function (legiAuth) {
                    if(service.isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                        if(legiAuth.soggettiEsterni) { 
                            return legiAuth.soggettiEsterni.some( function (soggEst) {
                                return soggEst.id === id;
                            });
                        }
                        return false;
                    }
                })) {
                    return true;
                }
            }
            return false;
        };

        // Estrae il campo id di un elemento
        // Se è un oggett,o prende il campo id, se è stringa restituisce l'elemento
        function getIdSoggetto(elemento) {
            var id;
            if (angular.isObject(elemento)) {
                id = elemento.id;
            } else {
                id = elemento;
            }
            return id;
        }
        
         /**
         * Restituisce true se l'utente appartiene ad uno o più dei settori 
         * forniti, false altrimenti.
         * 
         * @param {type} utente
         * @param {type} settori
         * @returns {Boolean}
         */
        service.hasAnySector = function (utente, sectors) {
            if (!utente || !utente.settori || !sectors) {
                return false;
            }
            for (var i = 0; i < sectors.length; i++) {
                var id = null;
                if (angular.isObject(sectors[i])) {
                    id = sectors[i].id;
                } else {
                    id = sectors[i];
                }
                if (utente.settori.indexOf(id) > -1) {
                    return true;
                }
            }
            return false;
        };

        /**
         * Restituisce true se l'utente ha ruolo settore e per uno o più
         * settori cui appartiene sono possibili le azioni specificate in
         * actions, false altrimenti. Il mapping delle azioni abilitate per
         * ciascun settore è definito da azioniSettoriById.
         * 
         * @param {type} utente
         * @param {type} actions
         * @param {type} azioniSettoriById
         * @returns {Boolean}
         */
        service.isSectorUserEnabled = function (utente, actions, azioniSettoriById) {
            if (Principal.hasAnyAuthority(['ROLE_SETTORE']) && utente.settori) {
                for (var i = 0; i < utente.settori.length; i++) {
                    var idSettore = utente.settori[i];
                    if (azioniSettoriById[idSettore]) {
                        return azioniSettoriById[idSettore].some(function (action) {
                            return actions.indexOf(action) > -1;
                        });
                    }
                }
            }
            return false;
        };

        /**
         * Restituisce true se l'utente ha ruolo commissione e all'interno
         * della commissione ha il ruolo commissionRoleName.
         * 
         * @param {type} utente
         * @param {type} commissioneRoleName
         * @returns {Boolean}
         */
        service.isCommissionRole = function (utente, commissioneRoleName, legislatura) {
            if(utente.commissioneRuolo && utente.commissioneRuolo.nome) {
                if( Principal.hasAnyAuthority(['ROLE_COMMISSIONE']) && utente.commissioneRuolo && utente.commissioneRuolo.nome === commissioneRoleName) {
                    return true;
                }
            }
            if(utente.legislaturaAuthorities && utente.legislaturaAuthorities.some(function (legiAuth){
                if(service.isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                    // LegiAuth ha qualche "commissioneRuoloAssociato" in cui commissioneRuolo.nome = commissioneRoleName --Principal.hasAnyAuthority(['ROLE_COMMISSIONE'], legislatura) && 
                    return legiAuth.commissioneRuoloAssociato && legiAuth.commissioneRuoloAssociato.some(function (commRuoloAssoc) {
                        return commRuoloAssoc.commissioneRuolo && commRuoloAssoc.commissioneRuolo.nome === commissioneRoleName;
                    });
                }
            })) {
                return true;
            }
            return false;
        };


        service.isCommissionRoleForCommissionId = function (utente, commissionId, commissionRole, legislatura) {

            if (utente && service.isCommissionUser(utente, legislatura)) {

                //Nella legislatura l'utente ha ROLE_COMMISSIONE -> Si controlla commissioneRuolo 
                // Gestione pregresso nelle autorities persistenti (non dovrebbe essere più popolato)
                var isCommissionRole = utente.commissioneRuolo && utente.commissioneRuolo.nome && utente.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toUpperCase();

                if (isCommissionRole) {
                    return true;
                }
                var legislaturaAuthorities = utente.legislaturaAuthorities;
                
                if(legislaturaAuthorities) {
                    // Controllo commissioneRuolo per le authorities della legislatura in input
                    var legiAuth = service.getLegislaturaAuthorities(utente, legislatura);
                
                    return legiAuth.commissioneRuoloAssociato.some(function(commRuolo) {
                        // Controlla se il nome del ruolo corrisponde
                        var roleMatch = commRuolo.commissioneRuolo && 
                                        commRuolo.commissioneRuolo.nome && 
                                        commRuolo.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toString().toUpperCase();
            
                        if (!roleMatch) {
                            return false;
                        }
            
                        // Controllo la specifica commissione: commissionId
                        if (commissionId) {
                            return commRuolo.commissione && 
                                    commRuolo.commissione.id && 
                                    commRuolo.commissione.id === commissionId;
                        } else {
                            // Se non si richiede la commissione specifica qui ho fatto il match con il ruolo -> Return true
                            return true;
                        }
                    });
                } else {
                    return false;
                }
            }
            return false;
        };

        /**
         * Restituisce true se l'utente appartiene alla commissione 
         * referente, false altrimenti.
         * @param {type} utente
         * @param {type} primaryCommissionIds
         * @returns {Boolean}
         */
        service.isPrimaryCommission = function (utente, primaryCommissionIds, legislatura) {
            if (utente !== null && utente.commissioni !== null && primaryCommissionIds) {
                for (var i = 0; i < utente.commissioni.length; i++) {
                    var idCommissione = utente.commissioni[i];
                    if (primaryCommissionIds.indexOf(idCommissione) > -1) {
                        return true;
                    }
                }
            }
            if(utente !== null && primaryCommissionIds && utente.legislaturaAuthorities && utente.legislaturaAuthorities.some(function (legiAuth){
                if (service.isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                    // LegiAuth ha qualche "commissioneRuoloAssociato" in cui commissione.id = primaryCommissionIds (id delle commissioni del parere referente)
                    return legiAuth.commissioneRuoloAssociato && legiAuth.commissioneRuoloAssociato.some(function (commRuoloAssoc) {
                        return commRuoloAssoc.commissione && primaryCommissionIds.indexOf(commRuoloAssoc.commissione.id) > -1;
                    });
                }
            })) {
                return true;
            }
            return false;
        };

        service.isLegislaturaAuthoritiesToCheck = function (legislaturaAuthority, legislatura) {
            if (!legislatura) {
                return true;
            }
            if (legislaturaAuthority.legislatura && 
                legislaturaAuthority.legislatura.legislatura && 
                parseInt(legislaturaAuthority.legislatura.legislatura, 10) === parseInt(legislatura, 10)) {
                return true;
            } else {
                return false;
            }
        };

        service.isSectionRoleEnabledForSection = function (utente, nomeSezione) {

            if (utente.authorities && utente.authorities.indexOf("ROLE_SECTION") !== -1
                 && utente.sectionAuthorities && utente.sectionAuthorities.length > 0) {

                for (var i = 0; i < utente.sectionAuthorities.length; i++) {
                    var authSectionName = utente.sectionAuthorities[i].nomeSezione;
                    if (authSectionName === nomeSezione) {
                        return true;
                    }
                }
            }
            return false;
        };

        service.isCommissionUser = function (utente, legislatura) {
            if(!legislatura) {
                return hasAuthority(utente, 'ROLE_COMMISSIONE');
            } else {
                var legiAuth = service.getLegislaturaAuthorities(utente, legislatura);
                if( legiAuth && legiAuth.authorities) {
                    return legiAuth.authorities.indexOf('ROLE_COMMISSIONE') > -1;
                } else {
                    return false;
                }
            }
        };

        service.isExternalUser = function (utente, legislatura) {
            if(!legislatura) {
                return hasAuthority(utente, 'ROLE_EXTERNAL');
            } else {
                var legiAuth = service.getLegislaturaAuthorities(utente, legislatura);
                if( legiAuth && legiAuth.authorities) {
                    return legiAuth.authorities.indexOf('ROLE_EXTERNAL') > -1;
                } else {
                    return false;
                }    
            }
        };

        service.isSectorUser = function () {
            return hasAuthority('ROLE_SETTORE');
        };

        service.isSectionUser = function () {
            return hasAuthority('ROLE_SECTION');
        };

        // Recupera le authorities di legsilatura per la legislatura in input
        service.getLegislaturaAuthorities = function(utente, legislatura) {
            if(utente && angular.isArray(utente.legislaturaAuthorities)) {
                return findByLegislatura(utente.legislaturaAuthorities, legislatura);
            } else  {
                return null;
            }
        };

        // Recupera l'oggetto CommissioneRuoloAssociato 
        // relativo alla commissione in input
        // Per la legislatura in input
        service.getCommissioneRuoloAssociato = function(utente, legislatura, commissione){
            var legAuth = utente.getLegislaturaAuthorities(legislatura);
            if (legAuth && angular.isArray(legAuth['commissioneRuoloAssociato'])) {
                for (var i = 0; i < legAuth['commissioneRuoloAssociato'].length; i++) {
                    var item = legAuth['commissioneRuoloAssociato'][i];
                    if (item.commissione && item.commissione.id === commissione.id) {
                        return legAuth.commissioneRuoloAssociato[i];
                    }
                }
            }
        };

        function findByLegislatura(legiAuths, legislatura) {
            for (var i = 0; i < legiAuths.length; i++) {
                if (legiAuths[i].legislatura && parseInt(legiAuths[i].legislatura.legislatura, 10) === parseInt(legislatura, 10)) {
                    return legiAuths[i];
                }
            }
            return null;
        }

        function hasAuthority(utente, authority) {
            return utente.authorities !== null
                    && angular.isDefined(utente.authorities)
                    && utente.authorities.indexOf(authority) > -1;
        }

        return service;
    }
})();
